/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CLOSE_BTN } from 'assets/images'
import { Modal } from 'shared'
import { GUILD_MESSAGE, PROFILE_MESSAGE } from 'i18n/constants'
import Button from 'shared/Button'
import { NUMBER } from 'apps/constants'
import { handleAsyncRequest } from 'utils/helper'
import ChooseMoreItemRewardStyled from './styled'
import guildApi from 'apis/guildApi'
import { useAppSelector } from 'hooks'
import { GetRaceListParams } from 'models'

interface ChooseMoreItemRewardProps {
  onSaveClick?: (value: any, type: string, ranking: string) => void
  onCloseButtonClick: () => void
  type?: string
  finalData?: any
  ranking?: string
}

const defaultParams: GetRaceListParams = {
  limit: NUMBER.FORTY,
  page: NUMBER.ONE
}

function ChooseMoreItemReward({
  onCloseButtonClick,
  onSaveClick = () => {},
  type,
  finalData,
  ranking
}: ChooseMoreItemRewardProps) {

  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [isLoading, setIsLoading] = useState(true)
  const [params] = useState<GetRaceListParams>(type === 'NFT' ? defaultParams : { ...defaultParams, limit: 40 })
  const [list, setList] = useState<any[]>([])

  const handleSelect = (id: number) => {
    const fieldKey = type === 'NFT' ? 'id' : 'booster_id'
    setList(prev =>
      prev.map(item => ({
        ...item,
        isSelected: item?.[fieldKey] === id ? true : false
      }))
    )
  }

  useEffect(() => {
    const fetchList = async () => {
      if (type === 'NFT') {
        const [error, result]: any = await handleAsyncRequest(guildApi.getVaultItems(profile.guild_id, params))
        if (error) {
          setIsLoading(false)
          return
        }
        if (result) {
          setIsLoading(false)
          const listNftsUsed: any[] = []
          Object.values(finalData)?.forEach((data: any) => {
            data.items.forEach((item: any) => {
              item.type === 'NFT' && listNftsUsed.push(item.id)
            })
          })
          const listCanUse = result.data.records.filter((itm: any) => !listNftsUsed.includes(itm.id))
          setList(
            listCanUse.map((it: any, index: number) => ({
              ...it,
              isSelected: finalData?.[ranking as string]?.items?.some((findItem: any) => findItem.id === it.id),
              no: index + 1,
            }))
          )
        }
      }
      if (type === 'NON_NFT' || type === 'NON-NFT') {
        const [error, result]: any = await handleAsyncRequest(guildApi.getVaultNonNftReward(profile.guild_id, params))
        if (error) {
          setIsLoading(false)
          return
        }
        if (result) {
          setIsLoading(false)
          const listNonNftsUsed: any[] = []
          Object.values(finalData)?.forEach((data: any) => {
            data.items.forEach((item: any) => {
              item.type === 'NON_NFT' && listNonNftsUsed.push(item)
            })
          })
          const listCanUse = result.data.records.filter((itm: any) => {
            const totalAmount = listNonNftsUsed.reduce((sum, item) => {
              return item.coin_type === itm.name ? sum + Number(item.amount) : sum
            }, 0)
            if (itm.quantity - itm.in_use > 0 && itm.quantity - itm.in_use > totalAmount) {
              return itm
            }
          })
          setList(
            listCanUse.map((it: any, index: number) => ({
              ...it,
              isSelected: false,
              no: index + 1,
            }))
          )
        }
      }
    }
    type && ranking && fetchList?.()
  }, [type, finalData, ranking])

  const handleOk = () => {
    const itemSelected = list.find(item => item.isSelected)
    itemSelected && onSaveClick?.(itemSelected, String(type), String(ranking))
  }

  return (
    <Modal>
      <ChooseMoreItemRewardStyled>
        <div className='choose-more-item-reward-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className='title-choose-more-item-container line-condition'>
            <div className={`color-primary`}>{t(`${PROFILE_MESSAGE}.chooseMoreItem`)}</div>
          </div>
          <div className='choose-more-item-container'>
            {isLoading ? (
              'Loading...'
            ) : (
              <div className='items-list-container'>
                <div className='grid-container-title'>
                  <div className='item-title'>No</div>
                  <div className='item-title'>Avatar</div>
                  <div className='item-title'>Item Name</div>
                  <div className='item-title'></div>
                </div>
                <div className='grid-container'>
                  {list.map(item => (
                    <Fragment key={item.id ?? item.booster_id}>
                      <div className='item'>{item.no}</div>
                      <div className='item'>
                        <img style={{ objectFit: 'contain' }} src={item.img} alt='image item' width={50} height={50} />
                      </div>
                      <div className='item'>{item.name}</div>
                      <div className='item'>
                        <input
                          disabled={item.isDisabled}
                          onChange={() => handleSelect(type === 'NFT' ? item.id : item.booster_id)}
                          type='radio'
                          checked={item.isSelected}
                          width="18px"
                          height="18px"
                        />
                      </div>
                    </Fragment>
                  ))}
                </div>
                <div className='action'>
                  <Button buttonName={t(`${GUILD_MESSAGE}.ok`)} onClickButton={handleOk} width={147} />
                </div>
              </div>
            )}
          </div>
        </div>
      </ChooseMoreItemRewardStyled>
    </Modal>
  )
}

export default ChooseMoreItemReward
